import { createContext, useContextSelector } from 'use-context-selector';
import { DEFAULT_CONTEXT_VALUE } from '../constants';
import { TaskCenterContext } from '../types';

export const TaskCenterProviderContext = createContext<TaskCenterContext>(DEFAULT_CONTEXT_VALUE);

export const useTaskCenterStore = <T extends (keyof TaskCenterContext)[]>(values: T) => {
  return useContextSelector(TaskCenterProviderContext, (context) =>
    values.reduce((acc, key) => ({ ...acc, [key]: context?.[key] }), {} as Pick<TaskCenterContext, T[number]>)
  );
};
